/**
 * Monarch rules return `frdcChatbot` as either:
 * - Variant: `{ value: { data: { sdkVersion, testfield, ... } }, componentId, ... }`
 * - Or nested: `{ data: { ... } }`
 * - Or already flat: `{ sdkVersion, testfield, ... }`
 *
 * Chat UI expects the **inner** data object (same shape as the JSON you edit in Monarch).
 */
export const resolveFrdcChatbotPayload = (frdcChatbot) => {
  if (frdcChatbot == null || frdcChatbot === false) return null;
  if (typeof frdcChatbot !== "object") return null;

  return frdcChatbot?.value?.data ?? frdcChatbot?.data ?? frdcChatbot;
};
